export default {
  title: 'Punkte verdient',
  points_one: '+1 Punkt',
  points_other: '+{{count}} Punkte',
};
